import * as XLSX from "xlsx";
import FileSaver from "file-saver";

export const ExportExcel = (
  csvData: any[],
  fileName: string,
  header?: string[]
) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const ws = XLSX.utils.json_to_sheet(csvData);

  if (header != null && header.length > 0) {
    XLSX.utils.sheet_add_aoa(ws, [header], { origin: "A1" });
  }
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};
